import React from 'react';
import PropTypes from 'prop-types';

import { useGetCurrentCompFilters } from 'common/react/components/competition-nav/hooks/use-get-current-comp-filters';
import { FixturesNav } from './FixturesNav';
import { FixturesList } from './fixtures-list/FixturesList';
import { FixturesSkeleton } from './fixtures-list/FixturesSkeleton';
import { EmptyState } from 'common/react/components/EmptyState';

export const Fixtures = (data) => {
    const { competitionId, compSeason, round, roundLoadError } =
        useGetCurrentCompFilters();

    return (
        <>
            <FixturesNav {...data} />

            <div className="wrapper widget">
                {roundLoadError ? (
                    <EmptyState cssClass="competition-nav__empty-state" />
                ) : !competitionId ||
                  !compSeason?.id ||
                  (!round?.roundNumber && round?.roundNumber !== 0) ? (
                    <FixturesSkeleton />
                ) : (
                    <FixturesList
                        competitionId={competitionId}
                        compSeason={compSeason}
                        round={round}
                    />
                )}
            </div>
        </>
    );
};

Fixtures.propTypes = {
    data: PropTypes.object
};
